import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  padding: 16px;\n  transition: all 0.3s;\n  min-height: 112px;\n\n  .title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n  }\n\n  .price,\n  desc {\n    font-size: 14px;\n    line-height: 22px; /* 157.143% */\n    letter-spacing: -0.14px;\n  }\n\n  .price {\n    color: ",
        ";\n    margin-right: 8px;\n  }\n\n  .desc {\n    color: ",
        ";\n    ::before {\n      content: '|';\n      margin-right: 8px;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);\n  height: 80px;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  border-radius: 2px;\n  max-width: unset;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  &.ant-divider {\n    border-block-start: 8px solid ",
        ";\n  }\n\n  &.ant-divider-horizontal {\n    margin: 0;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  background-color: red;\n\n  &.ant-drawer {\n    z-index: 1008 !important;\n  }\n\n  .ant-drawer-mask {\n    background: rgba(18, 20, 31, 0.2);\n  }\n\n  .ant-drawer-header {\n    padding: 0;\n\n    .close-btn {\n      display: none;\n    }\n\n    .ant-drawer-close {\n      display: none;\n    }\n  }\n\n  .ant-drawer-body {\n    padding: 0;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SideSheetHeader } from "@/components/SideSheets";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { numberFormatter } from "@/lib/utils";
import { Divider, Drawer } from "antd";
import Image from "next/image";
import React from "react";
import styled from "styled-components";
import { getProductHandoutType } from "src/api/product";
import { RelatedListItem } from ".";
import useHandoutProductStore from "../../../../store/relatedProduct";
import { FixedPurchaseSection } from "../FixedPurchaseSection";
export const MobileDisplayAllRelatedProduct = (param)=>{
    let { isOpenSideSheet , closeSideSheet , isFreepass  } = param;
    const { isLoggedIn  } = useAuthStore();
    const { relatedProducts , currentProduct  } = useHandoutProductStore((state)=>({
            relatedProducts: state.relatedProducts,
            currentProduct: state.currentProduct
        }));
    var _currentProduct_id;
    return /*#__PURE__*/ _jsxs(GNBSideSheetContainer, {
        open: isOpenSideSheet,
        onClose: closeSideSheet,
        destroyOnClose: true,
        width: "100%",
        zIndex: 1006,
        title: /*#__PURE__*/ _jsx(SideSheetHeader, {
            title: "연관 자료 함께 구매하기",
            onClose: closeSideSheet,
            goToPrevStep: closeSideSheet
        }),
        placement: "right",
        children: [
            /*#__PURE__*/ _jsxs(MobileRelatedProductWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(CurrentProduct, {
                        product: currentProduct
                    }),
                    /*#__PURE__*/ _jsx(MobileDivider, {}),
                    relatedProducts.map((product)=>{
                        return /*#__PURE__*/ _jsx(RelatedListItem, {
                            product: product,
                            isFreepass: isFreepass
                        }, product.id);
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FixedPurchaseSection, {
                isFreepass: isFreepass,
                handoutType: getProductHandoutType(currentProduct),
                productId: (_currentProduct_id = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.id) !== null && _currentProduct_id !== void 0 ? _currentProduct_id : 0,
                isLoggedIn: isLoggedIn
            })
        ]
    });
};
const FOOTER_HEIGHT = 82;
const MobileRelatedProductWrapper = styled.div.withConfig({
    componentId: "sc-65b05193-0"
})(_templateObject(), FOOTER_HEIGHT);
const CurrentProduct = (param)=>{
    let { product  } = param;
    return /*#__PURE__*/ _jsxs(CurrentProductContainer, {
        children: [
            /*#__PURE__*/ _jsx(ImageContainer, {
                className: "image-container",
                children: /*#__PURE__*/ _jsx(ThumbnailImage, {
                    alt: "book-img",
                    width: 56,
                    height: 80,
                    src: product.thumb_img
                })
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: product.title
                    }),
                    /*#__PURE__*/ _jsxs(SubStack, {
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                className: "price",
                                children: [
                                    numberFormatter(product.price),
                                    "원"
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "desc",
                                children: "이미 보고 있는 자료"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const CurrentProductContainer = styled.div.withConfig({
    componentId: "sc-65b05193-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_gray_100);
const ImageContainer = styled.div.withConfig({
    componentId: "sc-65b05193-2"
})(_templateObject2());
export const ThumbnailImage = styled(Image).withConfig({
    componentId: "sc-65b05193-3"
})(_templateObject3());
const Stack = styled.div.withConfig({
    componentId: "sc-65b05193-4"
})(_templateObject4());
const SubStack = styled.div.withConfig({
    componentId: "sc-65b05193-5"
})(_templateObject5());
const MobileDivider = styled(Divider).withConfig({
    componentId: "sc-65b05193-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_50);
const GNBSideSheetContainer = styled(Drawer).withConfig({
    componentId: "sc-65b05193-7"
})(_templateObject7());
